import React, { useEffect, useRef, useState } from "react";
import Adslot from "../../components/Adslot";

type QuizAdslotProps = {
    name: string;
    onClose?: () => void;
};

const QuizAdslot: React.FC<QuizAdslotProps> = ({ name, onClose }) => {

    const [isClosed, setClose] = useState<boolean>(false);
    const closeTimeout = useRef<NodeJS.Timeout | undefined>(undefined);

    useEffect(() => {
        setClose(false);

        if (closeTimeout.current)
            clearTimeout(closeTimeout.current);

        const { googletag } = window;

        googletag.cmd.push(() => {
            googletag.pubads().addEventListener('impressionViewable', (event: any) => {
                const slotId = event.slot.getSlotElementId();
                if (slotId === name) {
                    clearTimeout(closeTimeout.current as unknown as number);
                    closeTimeout.current = setTimeout(() => {
                        setClose(true);
                        closeTimeout.current = undefined;
                    }, 2000);
                }

            });
        });

        closeTimeout.current = setTimeout(() => {
            setClose(true);
            closeTimeout.current = undefined;
        }, 5000);

    }, [name]);

    useEffect(() => {
        if (isClosed)
            onClose?.();

    }, [isClosed]);

    return (
        <Adslot name={name} />
    );

};

export default QuizAdslot;